import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import Industries from '../components/Industries';
import CaseStudies from '../components/CaseStudies';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import TerminalEasterEgg from '../components/TerminalEasterEgg';
import { useState, useEffect } from "react";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-[#0B0F14] overflow-x-hidden">
      <Navbar />
      <Hero />
      <Services />
      <Industries />
      <HowItWorks />
      <CaseStudies />
      <Contact />
      <Footer />
      <TerminalEasterEgg />
    </div>
  );
};

export default Home;
